import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { BrowserModule } from "@angular/platform-browser";
import { AucFooterComponent } from "@auction-ui/footer/footer.component";
import { MfIconModule } from "@pattonair/material-framework";

@NgModule({
  declarations: [
    AucFooterComponent
  ],
  exports: [
    AucFooterComponent
  ],
  imports: [
    BrowserModule,
    MfIconModule,
    MatButtonModule,
  ],
})
export class AucFooterModule {
}